export default [{
  path: 'entpAuditManage',
  name: 'entpAuditManage',
  component: function component() {
    return import('@/views/recoveryManage/recoverySupplierManage/entpAuditManage/index');
  }
}, {
  path: 'entpAuditDetail',
  name: 'entpAuditDetail',
  component: function component() {
    return import('@/views/recoveryManage/recoverySupplierManage/entpAuditManage/detail');
  }
}, {
  path: 'entpLibraryManage',
  name: 'entpLibraryManage',
  component: function component() {
    return import('@/views/recoveryManage/recoverySupplierManage/entpLibraryManage/index');
  }
}, {
  path: 'entpLibraryDetail',
  name: 'entpLibraryDetail',
  component: function component() {
    return import('@/views/recoveryManage/recoverySupplierManage/entpLibraryManage/detail');
  }
}];